<app-header-redesign>
</app-header-redesign>

<router-outlet (activate)="onActivate($event)"></router-outlet>

<app-footer-redesign>
</app-footer-redesign>